// frontend/src/utils/monthTotalsUtils.js
export function toNum(v) {
  if (v === "" || v === null || v === undefined) return 0;
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

export function closeEnough(a, b, eps = 0.01) {
  return Math.abs(Number(a || 0) - Number(b || 0)) <= eps;
}

export function pickSelectedPractitionerRow(data, practitionerName) {
  const list = data?.practitioners;
  if (!Array.isArray(list)) return null;

  const target = String(practitionerName || "").trim();
  if (!target) return null;

  for (let i = 0; i < list.length; i++) {
    const row = list[i];
    if (!row) continue;

    const rowName = String(row.practitioner_name || row.practitioner || "").trim();
    if (rowName === target) return row;
  }

  return null;
}

export function mapTotalsFromRow(row) {
  if (!row) {
    return {
      total_production: 0,
      total_collection: 0,
      total_lab_costs: 0,
      total_material_costs: 0,
      total_invisalign_costs: 0,
      total_hours_worked: 0,
      total_per_day_number: 0,
      other_deduction_hours: [],
    };
  }

  return {
    total_production: Number(row.total_production || 0),
    total_collection: Number(row.total_collection || 0),
    total_lab_costs: Number(row.total_lab_costs || 0),
    total_material_costs: Number(row.total_material_costs || 0),
    total_invisalign_costs: Number(row.total_invisalign_costs || 0),
    total_hours_worked: Number(row.total_hours_worked || 0),
    total_per_day_number: Number(row.total_per_day_number || 0),
    other_deduction_hours: Array.isArray(row.other_deduction_hours)
      ? row.other_deduction_hours
      : [],
  };
}

export function buildMismatchDetails(expectedTotals, totals) {
  if (!expectedTotals) return [];

  const exp = {
    production: toNum(expectedTotals.production),
    collection: toNum(expectedTotals.collection),
    lab_costs: toNum(expectedTotals.lab_costs),
    material_costs: toNum(expectedTotals.material_costs),
    invisalign_costs: toNum(expectedTotals.invisalign_costs),
    hours_worked: toNum(expectedTotals.hours_worked),
  };

  const act = {
    production: Number(totals.total_production || 0),
    collection: Number(totals.total_collection || 0),
    lab_costs: Number(totals.total_lab_costs || 0),
    material_costs: Number(totals.total_material_costs || 0),
    invisalign_costs: Number(totals.total_invisalign_costs || 0),
    hours_worked: Number(totals.total_hours_worked || 0),
  };

  // keeps exact same compare logic, just removes repetition
  const rows = [
    { key: "Production", expKey: "production", actKey: "production" },
    { key: "Collection", expKey: "collection", actKey: "collection" },
    { key: "Lab Costs", expKey: "lab_costs", actKey: "lab_costs" },
    {
      key: "Material Costs",
      expKey: "material_costs",
      actKey: "material_costs",
    },
    {
      key: "Invisalign Costs",
      expKey: "invisalign_costs",
      actKey: "invisalign_costs",
    },
    { key: "Hours Worked", expKey: "hours_worked", actKey: "hours_worked" },
  ];

  const items = [];

  for (const r of rows) {
    if (!closeEnough(exp[r.expKey], act[r.actKey])) {
      items.push({
        key: r.key,
        expected: act[r.actKey],
        actual: exp[r.expKey],
      });
    }
  }

  return items;
}
